import {GrHistory} from "react-icons/gr";

import {FilterCategory, FilterSets} from "@/components/filterDropdown/FilterDropdown.ts";
import {Icon} from "@/components/icon/Icon";
import {KPIIconTypes} from "@/components/KPIIcon/KPIIcon.types.ts";
import {SummaryBar} from "@/components/summaryBar/SummaryBar.tsx";
import {SummaryBlock} from "@/components/summaryBar/SummaryBar.types.ts";
import {durationSecFn, roundDurationSecs} from "@/lib/format.tsx";
import {ServiceStats} from "@/lib/types/checks.ts";

interface ChecksSummaryBarProps {
  stats: ServiceStats;
  filterSets: FilterSets<FilterCategory>;
  onFilterSetChange: (filterSet: FilterSets<FilterCategory>) => void;
}

export const ChecksSummaryBar = ({stats, filterSets, onFilterSetChange}: ChecksSummaryBarProps) => {
  const summaryBlocks: SummaryBlock<ServiceStats>[] = [
    {
      applyFilterset: {status: ["up"]},
      title: "Running Checks",
      icon: KPIIconTypes.CHECKS_RUNNING,
      renderStat: (stats) => <>{stats.up}</>,
    },
    {
      applyFilterset: {status: ["down"]},
      title: "Down",
      icon: KPIIconTypes.CHECKS_DOWN,
      renderStat: (stats) => {
        const timeSinceAlert = stats.down_latest ? new Date().getTime() - new Date(stats.down_latest).getTime() : null;
        return (
          <>
            {stats.down}
            {timeSinceAlert && (
              <span className="mt-1 d-flex align-items-center gap-1 pulse-color-gray-600 pulseTextBodyTiny">
                <Icon icon={GrHistory} size="tiny" />
                Last Alert: {durationSecFn(roundDurationSecs(timeSinceAlert / 1000))}
              </span>
            )}
          </>
        );
      },
    },
    {
      applyFilterset: {status: ["paused"]},
      title: "Paused Checks",
      icon: KPIIconTypes.CHECKS_PAUSED,
      renderStat: (stats) => <>{stats.paused}</>,
    },
    {
      applyFilterset: {status: ["maintenance"]},
      title: "Maintenance Enabled",
      icon: KPIIconTypes.CHECKS_MAINTENANCE,
      renderStat: (stats) => <>{stats.maintenance}</>,
    },
  ];

  return (
    <SummaryBar
      stats={stats}
      summaryBlocks={summaryBlocks}
      className={"mb-3"}
      columns={{
        sm: 1,
        md: 2,
        lg: 2,
        xl: 4,
      }}
      filterSets={filterSets}
      onFilterSetChange={onFilterSetChange}
    />
  );
};
